import { connect } from 'react-redux';
import { updateSelectedAprTerm } from '../../actions/updateCalculator';
import TermSelect from '../../components/inputs/TermSelect';
import { getTermList, hasOEMSchedule } from '../../reducers/oemOverrides';

const mapStateToProps = (state, props) => {
	let aprTermsArray = state.calculatorData.initial.aprTerms;
	if (hasOEMSchedule(state.calculatorData.oemOverrides)) {
		aprTermsArray = getTermList(state);
	}
	const arrayLength = aprTermsArray.length;
	for (let i = 0; i < arrayLength; i++) {
		if (typeof aprTermsArray[i] === 'string') {
			aprTermsArray[i] = Number(aprTermsArray[i]);
		}
	}

	const selTerm = Number(state.calculatorData.current.selectedAprTerm);

	return {
		value: selTerm,
		list: aprTermsArray,
		passedProps: { ...props }
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		updateValue: (newValue) => {
			dispatch(updateSelectedAprTerm(newValue));
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(TermSelect);
